import { API } from 'src/api';
import { getTimeDifference } from 'src/utils/date-time-functions';

export const useTimerWidgetServices = () => {
  async function fetchTimer() {
    try {
      const response = await API.get('/timer/user');

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function startTimer(taskId: string) {
    const now = new Date().toISOString();
    try {
      const response = await API.post('/timer', {
        task: taskId,
        tasktype: 'board_task',
        startDate: now,
        startTime: now,
        label: [],
      });

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function stopTimer(taskId: string, startTime: string, isBillable: boolean) {
    const now = new Date().toISOString();
    try {
      const payload = {
        task: taskId,
        endTime: now,
        billable: isBillable,
        tasktype: 'board_task',
        duration: getTimeDifference(new Date(now), new Date(startTime)),
      };
      const response = await API.post('/timer/stop', payload);

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function pauseTimer(taskId: string, startTime: string, isBillable: boolean) {
    const now = new Date().toISOString();
    try {
      const payload = {
        task: taskId,
        endTime: now,
        billable: isBillable,
        tasktype: 'board_task',
        duration: getTimeDifference(new Date(now), new Date(startTime)),
        offset: getTimeDifference(new Date(now), new Date(startTime)),
      };
      const response = await API.post('/timer/stop', payload);

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function resumeTimer(taskId: string, startTime: string) {
    const now = new Date().toISOString();
    try {
      const payload = {
        task: taskId,
        offset: getTimeDifference(new Date(now), new Date(startTime)),
      };
      const response = await API.put('/timer', payload);

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  return {
    fetchTimer,
    startTimer,
    stopTimer,
    pauseTimer,
    resumeTimer,
  };
};
